var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectedUserManagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    strokeWidth: 1.5,
    stroke: "white",
    width: 32,
    height: 28,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9,11 C10.3807119,11 11.5,9.88071187 11.5,8.5 C11.5,7.11928813 10.3807119,6 9,6 C7.61928813,6 6.5,7.11928813 6.5,8.5 C6.5,9.88071187 7.61928813,11 9,11 Z",
    id: "shape-1",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeDasharray: "0,0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3,20 C3,16.6862915 5.6862915,14 9,14 C12.3137085,14 15,16.6862915 15,20 L15,20 L15,20",
    id: "shape-2",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeDasharray: "0,0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15,11 C16.3807119,11 17.5,9.88071187 17.5,8.5 C17.5,7.11928813 16.3807119,6 15,6",
    id: "shape-3",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeDasharray: "0,0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16.1344055,14.1070888 C18.9057082,14.6373905 21,17.0741212 21,20",
    id: "shape-4",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeDasharray: "0,0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedUserManagement);
export default __webpack_public_path__ + "static/media/Selected UserManagement.39e3f89fb0316ddb6e6522e91f7bc1b9.svg";
export { ForwardRef as ReactComponent };